import { useFormik } from 'formik';
import { useAppDispatch } from '../../App/redux/store';
import { updateAuthUserThunk } from '../../features/auth/services/authThunks';
import useAuth from '../../features/auth/useAuth';
import CompanyForm from '../../features/company/components/companyForm/CompanyForm';
import { updateCompanyThunk } from '../../features/company/services/companyThunks';
import useCompany from '../../features/company/useCompany';
import UserForm from '../../features/users/components/userForm/UserForm';
import CommonAccountFormButtons from './CommonAccountFormButtons';
import { detailsInitialValues, detailsSchema } from './detailsFormValues';
import './DetailsTab/UserDetails.scss';

const DetailsTab = () => {
  const { user, isManager, userIdIri } = useAuth({});
  const { company, companyIdIri } = useCompany();

  const dispatch = useAppDispatch();

  const formik = useFormik({
    initialValues: detailsInitialValues({ user, company: company.result }),
    validationSchema: detailsSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      if (values.userUpdated) {
        const { firstName, lastName, email, phoneNumber, enableNewsLetter } = values;
        const body = { firstName, lastName, email, phoneNumber, enableNewsLetter };

        dispatch(updateAuthUserThunk({ userIdIri, body: body }));
      }

      if (isManager && values.companyUpdated && companyIdIri) {
        const { address, city, country, siret, postalCode, name } = values;
        const body = { address, city, country, siret, postalCode, name };

        dispatch(
          updateCompanyThunk({
            companyIdIri: companyIdIri,
            body,
          }),
        );
      }
    },
  });

  return (
    <section className="my-account-content user-details">
      <form className="user-details-form">
        <div className="user-details-elt">
          <UserForm formik={formik} />
          {isManager && <CompanyForm formik={formik} />}
        </div>
        <CommonAccountFormButtons
          label="METTRE A JOUR MES COORDONNEES"
          handleSubmit={formik.handleSubmit}
        />
      </form>
    </section>
  );
};

export default DetailsTab;
